// Lazy load videos using IntersectionObserver
(() => {
  const lazyVideos = document.querySelectorAll('video.lazy-video');

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const sources = video.querySelectorAll('source[data-src]');

          sources.forEach(source => {
            source.src = source.dataset.src;
            delete source.dataset.src;
          });

          video.load();

          // Autoplay the video once loaded
          video.play().catch(err => {
            console.warn('Autoplay prevented:', err);
          });

          videoObserver.unobserve(video);
        }
      });
    }, {
      rootMargin: '50px'
    });

    lazyVideos.forEach(video => {
      videoObserver.observe(video);
    });
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    lazyVideos.forEach(video => {
      const sources = video.querySelectorAll('source[data-src]');
      sources.forEach(source => {
        source.src = source.dataset.src;
        delete source.dataset.src;
      });
      video.load();
      video.play().catch(err => {
        console.warn('Autoplay prevented:', err);
      });
    });
  }
})();
